module.exports = __webpack_public_path__ + "static/Aaron-b955761e22fe3b3637a261a43d8ece5b.png";